

































import { Component, Prop, Vue } from 'vue-property-decorator'
import { InputInterface } from '../types/Exa_Input'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

@Component({
    components: {
        FontAwesomeIcon
    }
})
export default class InputNumber extends Vue {
    @Prop() private libelle!: string
    @Prop() private description!: string
    @Prop() private value!: any
    @Prop() private ident!: any
    @Prop() private requis!: boolean
    @Prop() private data!: { min: any; max: any; step: any }
    @Prop() private disabled!: boolean
    @Prop() mode_lecture!: boolean
    @Prop() condition!: InputInterface
    @Prop({ default: false }) check_validation!: boolean

    /** 
     * checkKeyUp 
     * Vérifie si la valeur saisie est en dehors de la plage autorisée et affiche un message de console en conséquence. 
     * @param {any} e - L'événement de saisie clavier. 
     */
    checkKeyUp (e: any) {
        if (e.target.value < this.data.min || e.target.value > this.data.max) {
            console.log(e)
        }
    }

    /** 
     * inputHandler 
     * Gère les événements de saisie de l'input en émettant un événement avec l'identifiant et la valeur correspondants. 
     * @param {any} e - L'événement de saisie. 
     */
    inputHandler(e: any) {
        this.$emit('input', { ident: this.ident, value: e.target.value })
    }
}
